import Image from 'next/image';
import { SVGProps } from 'react';
import { motion } from 'framer-motion';
import COM1 from '../../assets/recruiter-page/community1.png';
import COM2 from '../../assets/recruiter-page/community2.png';
import RECRUITER_IMG from '../../assets/recruiter-page/widget_requirements.png';

const usplist1 = [
  {
    title: 'Peace of mind - ensure total compliance',
  },

  {
    title: 'Prevent fraud - reduce risk of counterfeit insurance certificate',
  },
  {
    title:
      'Boost candidate experience - seamless digital onboarding for your contractors',
  },
  {
    title:
      'Increase agency sales - earn ancillary revenue from insurance channels',
  },
  {
    title: 'Save time - and automate time-consuming agency admin',
  },
];

const usplist2 = [
  {
    title:
      'Access to articles on accounting, the contractor job market and how to maximise interview success',
  },
  {
    title:
      'Jove’s white-labelled job board allows agencies to post their own jobs and create greater engagement ',
  },
  {
    title:
      'A free assessment tool check IR35 compliance and stay informed on changing legislations',
  },
  {
    title: 'Ability to post your own exclusive and bespoke content',
  },
];

const BulletIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={40}
    height={40}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={40} height={40} rx={20} fill="#fff" />
    <rect width={40} height={40} rx={20} fill="#0E35D1" fillOpacity={0.1} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.707 15.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L18 22.586l7.293-7.293a1 1 0 0 1 1.414 0Z"
      fill="#0E35D1"
    />
  </svg>
);

export const USPSection = () => {
  return (
    <div className="bg-neutral-100 py-8 md:py-24">
      <div className="container">
        <h2 className="text-center">Supercharge agency compliance</h2>

        <div className="mt-8 grid grid-cols-1 gap-5 rounded-3xl bg-white lg:mt-16 lg:grid-cols-2 lg:gap-10">
          <div className="px-4 pt-8 lg:p-14 lg:pr-0">
            <span className="flex h-11 w-11 items-start justify-center rounded-full bg-black text-2xl font-bold leading-10 text-white">
              1
            </span>

            <div className="mt-6 space-y-5 lg:mt-24">
              <h3>Insurance validation</h3>

              <p className="text-lg lg:text-2xl">
                Jove’s insurance validation tool allows staffing agencies to
                automatically check contractor insurance cover, centralise
                document filing, and onboard new candidates faster.{' '}
              </p>
            </div>
          </div>

          <div className="flex min-h-[430px] w-full items-end rounded-3xl bg-pink-100">
            <motion.div
              initial={{ opacity: 0, y: 50, scale: 0.8 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                y: 0,
                transition: { duration: 0.5, delay: 0.4 },
              }}
              // viewport={{ once: true }}
              className="-mb-2"
            >
              <Image src={RECRUITER_IMG} alt="Widget" />
            </motion.div>
          </div>
        </div>

        <div className="rounded-3xl bg-white py-6">
          <div className="px-4 pt-8 lg:p-14 lg:pr-0">
            <h4>Why automate insurance with Jove?</h4>

            <ul className="mt-14 lg:columns-2">
              {usplist1.map((item, index) => (
                <li className="mb-5 flex items-center space-x-5" key={index}>
                  <BulletIcon className="flex-shrink-0" />
                  <p>{item.title}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 rounded-3xl bg-white lg:mt-16 lg:grid-cols-2 lg:gap-10">
          <div className="px-4 pt-8 lg:p-14 lg:pr-0">
            <span className="flex h-11 w-11 items-start justify-center rounded-full bg-black text-2xl font-bold leading-10 text-white">
              2
            </span>

            <div className="mt-6 space-y-5 lg:mt-24">
              <h3>Candidate engagement</h3>

              <p className="text-lg lg:text-2xl">
                Jove’s candidate engagement portal provides agencies with
                everything from a white labeled blog, a resource guidebook with
                IR35 tips, as well as their very own job board.
              </p>
            </div>
          </div>

          <div className="flex w-full items-end justify-center rounded-3xl bg-[#0E35D1AD]">
            <motion.div
              initial={{ opacity: 0, y: 50, scale: 0.8 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                y: 0,
                transition: { duration: 0.3, delay: 0.5 },
              }}
              className="-mb-2"
            >
              <Image src={COM2} alt="Widget" />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: -50, scale: 0.8 }}
              whileInView={{
                opacity: 1,
                scale: 1,
                y: 0,
                transition: { duration: 0.3, delay: 0.6 },
              }}
              className="mb-2"
            >
              <Image src={COM1} alt="Widget" />
            </motion.div>
          </div>
        </div>

        <div className="rounded-3xl bg-white py-6">
          <div className="p-5 lg:p-14 lg:pr-0">
            <h4>Delight your candidates with:</h4>

            <ul className="mt-14 lg:columns-2">
              {usplist2.map((item, index) => (
                <li className="mb-5 flex items-center space-x-5" key={index}>
                  <BulletIcon className="flex-shrink-0" />
                  <p>{item.title}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
